import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { ContentElement, GridCell, RowCell } from '@urbannex/storethemes';
import { Observable } from 'rxjs';
import { Section } from '../../../editor-container/editor-model';
import { EditState } from '../../../model';

export interface SectionBuilderState {
  section: Section;
  selectedCell?: GridCell | RowCell;
  selectedContent?: ContentElement;
  editState?: EditState
}

export const initialState: SectionBuilderState = {
  section: null,
  selectedCell: null,
  selectedContent: null,
  editState: EditState.EDITING
}

@Injectable({
  providedIn: 'root'
})
export class SectionBuilderStoreService extends ComponentStore<SectionBuilderState> {

  constructor() {
    super(initialState)
  }

  init(section: Section) {
    this.updateSection(section);
  }

  // Updaters
  readonly updateSection = this.updater((state: SectionBuilderState, section: Section) => {
    return {
      ...state,
      section: section
    }
  })

  readonly updateSelectedCell = this.updater((state: SectionBuilderState, selectedCell: GridCell | RowCell) => {
    return {
      ...state,
      selectedCell: selectedCell
    }
  })

  readonly updateContent = this.updater((state: SectionBuilderState, selectedContent: ContentElement) => {
    console.log(selectedContent);
    return {
      ...state,
      selectedContent: { ...selectedContent }
    }
  })
  readonly updateEditState = this.updater((state: SectionBuilderState, editState: EditState) => {
    console.log(editState)
    return {
      ...state,
      editState: editState
    }
  })

  // Selectors
  readonly section$: Observable<Section> = this.select(state => state.section);
  readonly selectedCell$: Observable<GridCell | RowCell> = this.select(state => state.selectedCell);
  readonly selectedContent$: Observable<ContentElement> = this.select(state => state.selectedContent);
  readonly editState$: Observable<EditState> = this.select(state => state.editState);

  // Effects



}
